// Polyfill for IE9+ and Safari
var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'firstElementChild';

// https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/firstElementChild#Polyfill_for_IE8_IE9_and_Safari
if (supportDescriptors) {
  // Objects types that implement ParentNode interface
  var protos = [Document.prototype, DocumentFragment.prototype];
  for (var i = 0; i < protos.length; i++) {
    var proto = protos[i];

    if (proto.hasOwnProperty(NAME)) {
      continue;
    }

    defineProperty(proto, NAME, {
      configurable: true,
      get: function () {
        var node, nodes = this.childNodes, i = 0;
        while (node = nodes[i++]) {
          if (node.nodeType === 1) {
            return node;
          }
        }
        return null;
      }
    });
  }
}
